// 次に使う絵を裏で先に読んでおく（初回の流れ：三百年前 → 酒呑の最終戦 → 三百年後 → 名前と姿 → 序章 → 里の初戦）。
// 読むだけ（ブラウザのキャッシュと画像シートの置き場に入る）。同時に読む数を絞り、今の画面の読み込みを邪魔しない
import { STORY_BY_ID } from '@hyakki/core/data/stories';
import { loadSheet, stageSheets } from './assets';
import { stageById } from './core-bridge';
import { actorPortrait, storyBackground, storyCastForLine } from './story/actors';

const warmed = new Set<string>();
const queue: string[] = [];
let running = 0;
function pump() {
  while (running < 3 && queue.length) {
    const url = queue.shift()!;
    running++;
    const img = new Image();
    img.decoding = 'async';
    img.onload = img.onerror = () => {
      running--;
      pump();
    };
    img.src = url;
  }
}

/** 画像を裏で読む（同じ URL は1回だけ） */
export function warmImages(urls: readonly (string | undefined)[]) {
  for (const u of urls) if (u && !warmed.has(u)) (warmed.add(u), queue.push(u));
  pump();
}

/** 物語の1話で使う背景と立ち絵 */
export function storyImages(id: string): string[] {
  const ep = STORY_BY_ID[id];
  if (!ep) return [];
  const out = new Set<string>();
  for (const l of ep.lines) {
    out.add(storyBackground(l.scene.background));
    for (const c of storyCastForLine(l)) {
      const p = actorPortrait(c);
      if (p) out.add(p);
    }
  }
  return [...out];
}

/** 戦場の画像シート（敵・建物・地形）を裏で1枚ずつ読む（今の画面の読み込みと回線を取り合わない） */
let sheetChain: Promise<unknown> = Promise.resolve();
export function warmStage(enemyIds: string[], terrain?: string) {
  for (const k of stageSheets(enemyIds, terrain)) sheetChain = sheetChain.then(() => loadSheet(k));
}
export function warmStageById(stageId: number) {
  const st = stageById(stageId);
  if (st) warmStage([...st.enemyIds, ...(st.bossId ? [st.bossId] : [])], st.terrain);
}
